import { Link } from '@mui/material';
import { Navigate, redirect, useNavigate, useParams } from 'react-router-dom';
import './index.css'
import React from 'react';


export default function LpGirandoChave() {
    return(
        <div className="pag_todo_lp">
            
            <div class="supertitulo">
        <h2>Curso + Workshop</h2>
    </div>
    
    <div class="titulo">
        <h2>Líder & Empresário 5.0</h2>
    </div>

    <div class="subtitulo">
        <h2>Os segredos para liderar, administrar e
            vencer, nas empresas de sucesso!</h2>
    </div>
    <div class="quadrado">
        
        <div class="textoSelo">
            <p>O curso número 1 
            do Brasil, com a maior aprovação por mais de
            60.000 lideres e empresários
            em mais de 300 empresas!</p>
                    </div>

        <div class="imgselo">
            <img src="https://www.nutrimixassessoria.com.br/wp-content/uploads/2015/07/nutrimix-selo-qualidade-e1436276117953.png"></img>
            <img src="https://www.nutrimixassessoria.com.br/wp-content/uploads/2015/07/nutrimix-selo-qualidade-e1436276117953.png"></img>
        </div>
        
    </div>

   
    


    <div class="container">
            <div class="card">
                <div class="box">
                    <div class="content">
                        <h2>?</h2>
                        <p>É crescer ou morrer!</p>
                        <h3>Sua empresa está preparada para o futuro?</h3>                      
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="box">
                    <div class="content">
                        <h2>?</h2>
                        <h3>Quais suas reais vantagens competitivas?</h3>
                        <p>Domine o mercado ou seja engolido por ele!</p>
                       
                    </div>
                </div>
            </div>

            
        
        </div>

        <div class="fraseImpacto">
            <h2>O QUE VOCÊ REALMENTE QUER PARA A SUA EMPRESA?</h2>
        </div>
        <div class="fraseImpactoInscrever">
            <h2>LÍDER & EMPRESÁRIO 5.0</h2>
        </div>

        <a class="inscrever" href="cursoLiderEmpresario.php">Inscreva-se!</a>

        



        <div class="textoLongo">
            <p>O mercado irá mudar de forma intensa a partir de 2023 e você 
                precisa estar preparado!
            </p>
        </div>

        <div class="primeiras">
            <div class="primeirasTexto">
                <p>"PARA QUE ESPERAR, SE VOCÊ PODE SE ANTECIPAR?"</p>
                <h2>Alex Born</h2>
            </div>
            
        </div>

        <div class="bonus">
            <div class="bonusTit">
                <h2>Bônus:</h2>
                <p>Para as 10 primeiras inscrições em cada cidade!</p>
            </div>
            <br></br>
            <div class="bonus1">
                <p><strong>- </strong>3 sessões de mentoria com o pesquisador
            neurocientista Alex Born</p>

            </div>

            <div class="bonus2">
                <p><strong>- </strong>MasterClass presencial em Neuromarketing
            e comunicação estratégica (Dezembro/2021)</p>

            </div>

            <div class="bonus3">
                <p><strong>- </strong>Livro sobre Neuromarketing e gatilhos mentais</p>

            </div>
        </div>

        <div class="fraseImpactoInscrever">
            <h2>LÍDER & EMPRESÁRIO 5.0</h2>
        </div>

        <a class="inscrever" href="cursoLiderEmpresario.php">Inscreva-se!</a>

        <div class="fraseJogada">
            <h2>O curso pratico que irá mudar a história da sua empresa!</h2>
        </div>


        <div class="container">
            <div class="card">
                <div class="box">
                    <div class="content">
                        
                        <h3>Líder & Empresário 5.0</h3>
                        <h3>Leme</h3>
                        <a href="conteudoLeme.php">Read more</a>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="box">
                    <div class="content">
                        
                        <h3>Líder & Empresário 5.0</h3>
                        <h3>Rio Claro</h3>
                        <a href="conteudoRioClaro.php">Read more</a>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="box">
                    <div class="content">
                        
                        <h3>Líder & Empresário 5.0</h3>
                        <h3>Piracicaba</h3>
                        <a href="conteudoPiracicaba.php">Read more</a>
                    </div>
                </div>
            </div>
        <div class="exclusivo">
            <h2>Conteúdo Exclusivo:</h2>

            <ul>
                <li>Competitividade e Autorresponsabilidade</li>
                <li>Como atrair os clientes e voltar a crescer</li>
                <li>Comunicação estratégica</li>
                <li>Neuromarketing: A mente dos consumidores</li>
                <li>Estratégicas comerciais e inovadoras</li>
                <li>Relacionamento com clientes</li>
                <li>Geração de demandas e oportunidades</li>
                <li>Negociação e Quebra de objeções</li>
                <li>Auto Liderança e Inteligência emocional</li>
                <li>Gestão de conflitos em empresas familiares</li>
                <li>Gestão financeira e Fluxo de caixa</li>
                <li>Produtividade e Motivação</li>
                <li>Compromisso e Engajamento</li>
                <li>Organização estratégica</li>
            </ul>


        </div>

        <div class="palestrante">
            <div class="fotoPales">
                <div class="circuloPalestra">
                    <img src="http://alexborn.com.br/img/fotoStory.webp"></img>
                </div>
            </div>
            <div class="textoPalestrante">
                <h2>Alex Born</h2>
                <p>"Com o pesquisador neurocientista Alex Born,
                    especialista em estratégicas inovadoras de
                    comunicação, considerado o “Pai do Neuromarketing
                    no Brasil” e um dos profissionais mais influentes do
                    mercado, com trabalhos realizados em 23 países,
                    assistido por milhões de pessoas, em multinacionais,
                    universidades e grandes eventos mundiais, como:
                    Copa do Mundo, Olimpíadas, Congresso Mundial
                    de Marketing e Vendas, WOB, entre outros."</p>
            </div>
        </div>

        <a class="inscrever2" href="cursoLiderEmpresario.php">Inscreva-se</a>
        </div>
        </div>
    )

}